import isUndefined from "lodash/isUndefined";
export var showProductPromotions = function(promoPrice) {
    if (!promoPrice) {
        return false;
    }
    return !isUndefined(promoPrice.discount_bps) && !isUndefined(promoPrice.discounted_item_price);
};
